import Raven from 'raven-js';
import { GET_PUBLIC_FEATURE_FLAGS } from '../queries/featureFlagQueries';
import { getBrowserLocale, getCountryCode } from '../utils/getPreferredLanguage';
import { getUtk } from '../utils/getUtk';
import { DEFAULT_CHIRP_TIMEOUT } from '../constants/chirpDefaults';
import { dataFetchingClient } from '../dataFetchingClient';
export function fetchPublicPricingPageDetails() {
  const browserLocale = getBrowserLocale();
  const utk = getUtk() || '';
  const preferredCountryCode = getCountryCode();
  dataFetchingClient.query({
    query: GET_PUBLIC_FEATURE_FLAGS,
    variables: {
      utk,
      browserLocale,
      preferredCountryCode
    },
    context: {
      timeout: DEFAULT_CHIRP_TIMEOUT
    }
  }).catch(error => {
    Raven.captureException(error, {
      fingerprint: ['failed-to-fetch-public-feature-flags']
    });
  });
}